import RouteTemplate from 'ember-route-template'
import type { TOC } from '@ember/component/template-only'
import { FeatureModal } from 'district-ui-client/components/feature-modal'
import { Toaster } from 'district-ui-client/components/toaster'
import { MirageScenario } from 'district-ui-client/components/mirage-scenario'
import { DialogContainer } from 'district-ui-client/components/dialog'
import { WalkMe } from 'district-ui-client/components/walk-me'

const ApplicationTemplate: TOC<unknown> = <template>
  <WalkMe />
  {{! temporary custom background color https://3plearning.atlassian.net/browse/YETI-5789 }}
  <div class="flex h-screen flex-col items-stretch bg-[#FAFBFC] print:bg-white">
    {{outlet}}
    <FeatureModal />
  </div>

  <DialogContainer />

  <Toaster class="fixed right-7 top-[72px] mt-10" />

  <div class="fixed bottom-0 left-0 z-50 opacity-50 hover:opacity-100 print:hidden">
    <MirageScenario class="border border-black bg-white p-1" />
  </div>
</template>

export default RouteTemplate(ApplicationTemplate)
